var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable */
import { action, observable } from 'mobx';
const Default = {
    id: -1,
    name: '',
    researcherId: 1,
    accountManagerId: 1,
    note: '',
    parentCompanyId: -1,
    organizationNumber: '',
    accountManagerName: 'acoountManagerFirstName',
    language: ''
};
export class Company {
    constructor(company = Default) {
        this.fromJson(company);
    }
    fromJson(company) {
        Object.assign(this, company);
    }
    toJson() {
        return {
            id: this.id,
            name: this.name,
            note: this.note,
            departments: this.departments,
            costCenters: this.costCenters,
            researcherId: this.researcherId,
            parentCompanyId: this.parentCompanyId,
            accountManagerId: this.accountManagerId,
            organizationNumber: this.organizationNumber,
            accountManagerName: this.accountManagerName,
            language: this.language,
            subsidiaries: this.subsidiaries,
            tfoAcceptsOrDeniesCandidate: this.tfoAcceptsOrDeniesCandidate,
            isSSOEnabled: this.isSSOEnabled,
        };
    }
}
__decorate([
    observable
], Company.prototype, "id", void 0);
__decorate([
    observable
], Company.prototype, "name", void 0);
__decorate([
    observable
], Company.prototype, "note", void 0);
__decorate([
    observable
], Company.prototype, "departments", void 0);
__decorate([
    observable
], Company.prototype, "researcherId", void 0);
__decorate([
    observable
], Company.prototype, "parentCompanyId", void 0);
__decorate([
    observable
], Company.prototype, "accountManagerId", void 0);
__decorate([
    observable
], Company.prototype, "organizationNumber", void 0);
__decorate([
    observable
], Company.prototype, "costCenters", void 0);
__decorate([
    observable
], Company.prototype, "accountManagerName", void 0);
__decorate([
    observable
], Company.prototype, "language", void 0);
__decorate([
    observable
], Company.prototype, "subsidiaries", void 0);
__decorate([
    observable
], Company.prototype, "tfoAcceptsOrDeniesCandidate", void 0);
__decorate([
    observable
], Company.prototype, "isSSOEnabled", void 0);
__decorate([
    action
], Company.prototype, "fromJson", null);
__decorate([
    action
], Company.prototype, "toJson", null);
